import { ContactPreference } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { ContactPreferenceClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export const useContactPreferenceListQuery = () => {
  return useQuery({
    queryKey: [queryKeys.contactPreferences.root, queryKeys.contactPreferences.list],
    queryFn: async () => {
      const req = ContactPreference.create({ active: 1, withoutLimit: true });
      const res = await ContactPreferenceClientService.BatchGet(req);
      return res.results;
    },
    staleTime: 5 * 60 * 1000,
  });
};
